import { clearModal } from '@shoflo/studio-redux/actions';
import { LOST_REALTIME_SOCKET_CONNECTION } from 'constants/Modal';
import { StudioLogger } from '@studio/logger/StudioLogger';

const logger = new StudioLogger('socket-dispatcher');

function clearLostRealTimeMessage(dispatch, getState) {
  window.realtimeConnectionLostTimeout = null;
  dispatch(clearModal(LOST_REALTIME_SOCKET_CONNECTION));

  const {
    meeting: { attendeeResponse }
  } = getState();
  const payload = {
    attendeeId: attendeeResponse?.Attendee?.AttendeeId ?? 'unavailable'
  };

  logger.info('Realtime socket connected', payload);
}

function socketConnected({ dispatch, getState }) {
  clearLostRealTimeMessage(dispatch, getState);
}

export default socketConnected;
